import React from 'react';
import './style.css';

interface InputFieldProps {
  id?: string;
  label?: string;
  placeholder?: string;
  helper?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  hasError?: boolean;
  disabled?: boolean; // Added disabled prop
  maxLength?: number;
}

const TextArea: React.FC<InputFieldProps> = ({
  id,
  label,
  placeholder,
  helper,
  value,
  onChange,
  hasError,
  disabled,
  maxLength
}) => (
  <div className="input-field">
    {label && <label style={{marginBottom:0}}>{label} <mark style={{ background: 'transparent', color: 'red' }}>*</mark></label>}
    {label && <span className='info-text-address'>Used as your business communication address.</span>}
    <textarea
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      className={hasError ? 'error-border textarea' : 'textarea'}
      disabled={disabled} // Added disabled attribute
      maxLength={maxLength}
    ></textarea>
    {maxLength && <span className='info-text-address'>{(value || '').length}/{maxLength} characters</span>}
    {helper && <p className="helper">{helper}</p>}
  </div>
);

export default TextArea;